import axiosInstance from 'src/api/axios';
import { toast } from 'react-toastify'

export const getCandidatesByBatchId = async (currentPage, limit, batchId) => {
    try {
      let response = await axiosInstance.get(`apiBatch/singleBatch/${batchId}`,{
        params: {
          page: currentPage,
          limit: limit
        }
      })
      if (response.status == '200') {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching records:', error);

    }
  }